import watch from "redux-watch";
import isEqual from 'is-equal';
import { watchRedux }  from 'utilities/redux-watcher';

import { deepmerge } from 'utilities/merge';
import { getDataByDot, newDataFromDot } from 'utilities/hash';


type RiotOnMountCallbacks = [ () => void ]
export class RiotTagMixin implements riot.TagMixin {
  // riot members definition
  // init?(): void;
  opts?: any;
  parent?: riot.Tag;
  tags?: {
      [key: string]: riot.Tag | riot.Tag[];
  };
  root?: Node;
  isLoop?: boolean;
  hasImpl?: boolean;
  item?: any;
  update?(data?: any): void;
  mixin?(mixinName: string): void;
  mixin?(mixinObject: riot.TagMixin): void;
  unmount?(keepTheParent?: boolean): void;
  on?(events: string, callback: Function): riot.Observable;
  one?(events: string, callback: Function): this;
  off?(events: string): this;
  off?(events: string, callback: Function): this;
  trigger?(events: string, ...args: any[]): this;
}

export class BaseTag extends RiotTagMixin {
  //
  // jbuilderのつくるjson.data.~~~~~の部分。Reduxのstore.getState().data.~~~~~~と一致させる。
  protected tagScope: string;
  protected baseTagScope: string;
  protected tagLocale: any;
  protected topScope: string = 'data'
  // mount時に呼ばれるコールバック関数の配列
  private onMounts:RiotOnMountCallbacks;
  // falseの場合turbolinksによってunmountされた際にunsbscribeする
  protected watchPermenent:boolean =  false;
  // タグ作成時にsomething-tag(tag-scope="xxxx.yyyy.zzzz")のように渡しておく。
  public init(): void {
    this.setDefaultOptions();
    this.on('unmount', ()=>{
      this.rootElement().remove();
    });
    // optsにtagScopeがあればそれを設定
    if(this.opts.tagScope) { this.tagScope = this.opts.tagScope }
    if(this.opts.baseTagScope) { this.baseTagScope = this.opts.baseTagScope }
    this.mergeOpts();
    // this.on('update', () => { console.log(this.rootElement()); })
  }
  // コンポーネントにoptsの初期値があればオーバーライドして設定
  protected setDefaultOptions(){}
  // Reduxのsubscribeメソッドのラッパーメソッド
  // 特定のスコープ(App.store.getState().~~~~~~の部分)のみの変化で通知がされるようにredux-watchを使用
  protected watch(callback: (newVal: any, oldVal: any, objectPath: string) => void = this.onChangeStore) {
    let callbackHack = (a, b, c)  => { setTimeout(() => {callback(a, b, c); }, 1)}
    this.watchData(this.fullScope(), callbackHack );
  }

  protected watchData(scope:string, callback: (newVal: any, oldVal: any, objectPath: string) => void){
    let w = watchRedux(App.store.getState, scope);
    let unsubscribe = App.store.subscribe(w((newVal, oldVal, objectPath) => {
      callback(newVal, oldVal, objectPath);
    }), this.watchPermenent);
    this.on('unmount', () => {
      unsubscribe();
    })
    return unsubscribe
  }
  protected getState(){
    return App.store.getState()
  }

  protected fullScope(){
    return this.topScope + '.' + this.tagScope;
  }
  // Reduxのdispatchメソッドのラッパーメソッド
  // 特定のスコープ内のデータのみ渡す仕様。
  // つまり、実際にはtags.hogehoge_tag.nameのみ渡す場合でも
  // { hogehoge_tag: { name: 'new_name' }ではなく { name: 'new_name' }だけ渡す
  protected dispatch(val: any) {
    let newVal = this.newData(val)
    this.dispatchNewValue(newVal);
  }

  protected newData(val: any) {
    return newDataFromDot(val, this.tagScope);
  }

  protected dispatchNewValue(newVal: any) {
    App.store.dispatch(this.dispatchAction()(newVal));
  }

  protected dispatchAction(){
    return App.actions.data.update;
  }
  // riotTagのoptsにjson.tags.hogehogeの内容やApp.store.getState().hogehogeの内容を
  // マージさせるためのメソッド
  protected mergeOpts(opts: any = null): boolean {
    if(!this.tagScope){ return false; }
    opts = opts || this.getDataFromTagScope();
    this.opts = deepmerge(this.opts, opts, true);
    if(this.opts.merge){
      this.opts = deepmerge(this.opts, this.opts.merge, true);
      delete this.opts['merge'];
    }
    if(this.baseTagScope){
      this.opts = deepmerge(this.getDataFromBaseTagScope(), this.opts, true);
    }
    this.onMergeOpts();
    return true;
  }
  protected onMergeOpts(){}
  // scopeの.（ドット）を切り分けて、tagからオブジェクトを取り出す。
  protected getDataFromTagScope(): any {
    if(!this.tagScope){ return false; }
    let scopes: Array<string> = this.tagScope.split('.')
    return this.getDataFromScopes(scopes);
  }
  protected getDataFromBaseTagScope(): any {
    if(!this.baseTagScope){ return false; }
    let scopes: Array<string> = this.baseTagScope.split('.')
    return this.getDataFromScopes(scopes);
  }
  protected getDataFromScopes(scopes){
    let current = this.data();
    for(let i in scopes) {
      let _i: number = parseFloat(i);
      let scope: string = scopes[i];
      if(current[scope] == undefined){
        // console.warn(scopes.join('.') + ': ' + scope + ' is not defind at jbuilder');
        return false;
      }
      if(_i === scopes.length - 1) {
        return current[scope]
      } else {
        current = current[scope]
      }
    }
    return {};
  }
  // subscribeのデフォルトコールバック
  // 新しい値をoptsにセットし、ビューをアップデートさせる動作
  // 変更したい場合はこのメソッドをオーバーライド、もしくはwatchの時に別のcallbackを渡す
  public onChangeStore(newVal, oldVal, objectPath) {
    this.mergeOpts(newVal);
    this.update();
  }

  // riotTag.on('mount', callback)のラッパーメソッド
  // 引数がない場合はonMountメソッドが呼ばれるのでonMountメソッドをサブクラスで用意する
  // 引数には配列を入れる、すべてコールバックメソッド。
  // 順番にコールバックが呼ばれるようになる
  // 例：this.listenMount([this.onMount, this.onMount2])
  public listenMount(callbacks: RiotOnMountCallbacks) {
    if(this.onMounts == undefined) {
      this.onMounts = callbacks;
    } else {
      this.onMounts = <RiotOnMountCallbacks>this.onMounts.concat(callbacks)
    }
    this.off('mount', this.onMountRiotTag);
    this.on('mount', this.onMountRiotTag);
  }
  //
  private onMountRiotTag(): void {
    for(let callback of this.onMounts) {
      callback();
    }
  }

  public rootElement(): HTMLElement {
    return <HTMLElement>this.root;
  }

  public locale() {
    if(this.tagLocale){ return this.tagLocale; }
    let data = App.store.getState().data.locales;
    this.tagLocale = data[this.tagName()];
    return this.tagLocale;
  }

  protected tagName(){
    return this.root.nodeName.toLowerCase();
  }

  public asset() {
    return App.store.getState().asset;
  }

  public data() {
    return App.store.getState()[this.topScope];
  }

  public parentTagScope(){
    return this.tagScope.substr(0, this.tagScope.lastIndexOf('.'));
  }
  public topTagScope(){
    return this.tagScope.substr(0, this.tagScope.indexOf('.'));
  }

  public parentOpts(){
    return this.parent.opts;
  }

  public querySelector(selector:string) :Element {
    return this.rootElement().querySelector(selector);
  }

  public querySelectorAll(selector:string) :NodeListOf<Element> {
    return this.rootElement().querySelectorAll(selector);
  }

  // onMountメソッドは一般的すぎて重複するのでprivateにする。
  // onMountSubClassメソッドのような名前を代わりに使用する
  private onMount() {}
}

riot.mixin('base', BaseTag as riot.TagMixin);
